<template>
  <CadastroBase
    nomePlural="SupportSubjects"
    nomeSingular="SupportSubject"
    :camposObrigatorios="[{ campo: 'nome', label: 'Nome' }]"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="8">
          <v-text-field
            v-model.trim="recurso.nome"
            :label="$t('Nome')"
            name="nome"
            maxlength="200"
            obrigatorio
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-text-field
            v-model.number="recurso.ordem"
            :label="$t('Ordem')"
            name="ordem"
            type="number"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-checkbox v-model="recurso.ativo" :label="$t('Ativo')" />
        </v-col>
      </v-row>
    </v-col>
  </CadastroBase>
</template>

<script>
import CadastroBase from "@/components/base/Crud/CadastroBase";
import { createSupportSubjectDataService } from "@/services/support/SupportSubjectDataService";

export default {
  name: "CadastroSupportSubject",
  components: { CadastroBase },
  data() {
    const supportScope =
      this.$route?.meta?.supportScope || this.$route?.query?.escopo || null;
    return {
      DataService: createSupportSubjectDataService(supportScope),
      recurso: {
        nome: "",
        ordem: 0,
        ativo: true,
      },
    };
  },
  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },
  },
};
</script>
